/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerDetailsViewModelResult } from '../../models/player-details-view-model-result';

export interface ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Params {
  competitionId: number;
  id: number;
}

export function apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal(http: HttpClient, rootUrl: string, params: ApiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerDetailsViewModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal.PATH, 'get');
  if (params) {
    rb.path('competitionId', params.competitionId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerDetailsViewModelResult>;
    })
  );
}

apiPlayerCompetitionIdIdGet$JsonOdataMetadataMinimal.PATH = '/api/player/{competitionId}/{id}';
